import { render, staticRenderFns } from "./CSProductStat.vue?vue&type=template&id=69725c6f&lang=pug&"
import script from "./CSProductStat.vue?vue&type=script&lang=js&"
export * from "./CSProductStat.vue?vue&type=script&lang=js&"
import style0 from "./CSProductStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports